import { render, staticRenderFns } from "./EditIdsEndpointDialog.html?vue&type=template&id=4776712c&external"
import script from "./EditIdsEndpointDialog.js?vue&type=script&lang=js&external"
export * from "./EditIdsEndpointDialog.js?vue&type=script&lang=js&external"
import style0 from "./EditIdsEndpointDialog.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports